import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import { TextField } from '@material-ui/core';

import {
  Portlet,
  PortletHeader,
  PortletLabel,
  PortletContent,
  PortletFooter
} from 'components';

let styles = theme => ({
  field: {
    margin: theme.spacing(3)
  },
  textField: {
    width: '420px',
    maxWidth: '100%',
    marginRight: theme.spacing(3)
  },
});

class Website extends Component {

  constructor(props) {
    super(props);
    this.state = {
      website: props.website,
      citation: props.citation,
      error: null
    };
  }

  onChange(path, value) {
    let website = this.state.website;
    _.set(website, path, this.fromViewValue(value));
    this.setState({ website });
    this.state.citation.relationships.website = website;
  }

  fromViewValue(value) {
    return value === '' ? null : value;
  }

  render() {
    const { classes, website } = this.props;
    return (
      <form autoComplete="off" noValidate>
        <div className={classes.field}>
           <TextField
            className={classes.textField}
            label="Site Name"
            margin="dense"
            required
            value={website.attributes.siteName || ''}
            variant="outlined"
            onChange={(event) => this.onChange('attributes.siteName', event.target.value)}
          />
        </div>
      </form>
    );
  }
}

Website.propTypes = {
  citation: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  website: PropTypes.object
};

Website.defaultProps = {
  website: {
    attributes: {},
    relationships: {}
  }
};


export default withStyles(styles)(Website);
